import { takeLatest, call, put, all } from 'redux-saga/effects';
import { 
  getColorListFailure, 
  getColorListSuccess 
} from '../_actions/general.actions';
import { generalConstants } from '../_constants';
import { fetchColors } from '../_services/general.service';

export function* getColorListAsync({ payload }) {
  try {
    const result = yield call(fetchColors, payload);
    yield put(getColorListSuccess({type: payload, data: result.data}));
  } catch (error) {
    yield put(getColorListFailure(error.message));
  }
}

export function* getColorListStart() {
  yield takeLatest(generalConstants.GET_COLOR_LIST_START, getColorListAsync);
}
export function* generalSagas() {
  yield all([call(getColorListStart)]);
}
